import axios from 'axios'

export default {
  getActions() {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/actions').then((response) => {
      return response
    })
  },
  createAction(action) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/actions', action).then((response) => {
      return response
    })
  },
  deleteAction(actionId) {
    return axios.delete(process.env.VUE_APP_BACKEND_BASE_URL + '/actions/' + actionId).then((response) => {
      return response
    })
  }
}
